import React, { useCallback, useEffect } from "react";
import { getProperties } from "../../../Services";
import { AutocompleteComponent } from "../../Controls";
import { ReskinningAutocomplete } from "../../V2";
import { useDebouncedAction } from "../../../Hooks/DebouncedAction";

const PropertyAutocomplete = ({ value, onChange, isNewLayout, ...props }) => {
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const getPropertiesSearch = useCallback(
    useDebouncedAction(async (searchText) => {
      setLoading(true);
      const result = await getProperties({
        pageIndex: 0,
        pageSize: 100,
        search: searchText,
      });
      if ("result" in result) {
        setData(result.result);
      }
      setLoading(false);
    }),
    []
  );
  useEffect(() => {
    getPropertiesSearch();
  }, [getPropertiesSearch]);

  if (isNewLayout) {
    return (
      <ReskinningAutocomplete
        data={data}
        isLoading={loading}
        onInputChange={(_e, value) => getPropertiesSearch(value)}
        displayLabel={(item) => item.property.property_name}
        multiple={false}
        getOptionSelected={(item, value) =>
          item.propertyId === value.propertyId
        }
        selectedValues={value}
        onChange={onChange}
        withoutSearchButton
        filterOptions={(options, state) =>
          options.filter(
            (option) =>
              option.property.property_name
                .toLowerCase()
                .includes(state.inputValue.toLowerCase()) ||
              option.propertyId === +state.inputValue
          )
        }
        {...props}
      />
    );
  }

  return (
    <AutocompleteComponent
      data={data}
      isLoading={loading}
      onInputChange={(_e, value) => getPropertiesSearch(value)}
      displayLabel={(item) => item.property.property_name}
      multiple={false}
      getOptionSelected={(item, value) => item.propertyId === value.propertyId}
      selectedValues={value}
      onChange={onChange}
      withoutSearchButton
      filterOptions={(options, state) =>
        options.filter(
          (option) =>
            option.property.property_name
              .toLowerCase()
              .includes(state.inputValue.toLowerCase()) ||
            option.propertyId === +state.inputValue
        )
      }
      {...props}
    />
  );
};
export default PropertyAutocomplete;
